import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  constructor(public http: HttpClient) { }
  public getAddressDetails(): Observable<any> {
    return this.http.get(environment.BASE_URL_PROFILE + '/profile/getAddresses')
  }
  public getDistrictsByCityId(cityId): Observable<any> {
    return this.http.get(environment.BASE_URL_COMMON + 'cmn/getDistrictByCityId/' + cityId)
  }
  public getPostalCodeByCityId(cityId): Observable<any> {
    return this.http.get(environment.BASE_URL_COMMON + 'cmn/getPostalCodeByCityId/' + cityId)
  }
  public saveAddress(payload): Observable<any> {
    return this.http.post(environment.BASE_URL_PROFILE + 'profile/saveAddress', payload)
  }
  public postSaveUserProfile(payload): Observable<any> {
    return this.http.post(environment.BASE_URL_PROFILE + 'profile/savePersonalDetails', payload)
  }
}
